import { render, staticRenderFns } from "./ProfessionalDevelopment.vue?vue&type=template&id=626bd0fc&"
import script from "./ProfessionalDevelopment.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports